var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-alert",
        {
          staticClass: "p-5",
          attrs: {
            variant: "danger",
            dismissible: "",
            show: _vm.error.isVisible
          },
          on: {
            dismissed: function($event) {
              _vm.error.isVisible = false
            }
          }
        },
        [
          _c(
            "i18n",
            { attrs: { path: _vm.error.path, tag: "div" } },
            [
              _c(
                "b-link",
                {
                  attrs: {
                    href: "mailto:support@meine-vertraege.net",
                    place: "supportLink"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("message.support.email")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0" },
        [
          _c("h4", [_vm._v(_vm._s(_vm.$t("message.signUpConfirm.title")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.signUpConfirm.message")))]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit($event)
                }
              }
            },
            [
              _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.confirmData.verificationCode.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.signUpConfirm.verificationCode"
                            )
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "message.signUpConfirm.input.placeholder.verificationCode"
                              ),
                              state: _vm.$v.confirmData.verificationCode.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.confirmData.verificationCode.$touch()
                              }
                            },
                            model: {
                              value: _vm.confirmData.verificationCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.confirmData,
                                  "verificationCode",
                                  $$v
                                )
                              },
                              expression: "confirmData.verificationCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "i18n",
                        {
                          attrs: {
                            path: "message.signUpConfirm.again",
                            tag: "p"
                          }
                        },
                        [
                          _c(
                            "b-link",
                            {
                              attrs: { href: "#", place: "resendLink" },
                              on: { click: _vm.resendConfirmationCode }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.signUpConfirm.btn.resend")
                                ) + "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-link",
                            {
                              attrs: {
                                href: "mailto:support@meine-vertraege.net",
                                place: "supportLink"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.support.email")) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-btn",
                        { attrs: { variant: "link" }, on: { click: _vm.back } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.signUpConfirm.btn.back"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-btn",
                        { attrs: { variant: "primary", type: "submit" } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.signUpConfirm.btn.send"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56bcabb1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56bcabb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SignUpConfirm.vue
// module id = jDXG
// module chunks = 1